module.exports = __webpack_public_path__ + "media/images/linkedin-575839ae34a6264637f3bb8523038d51.png";